// extracted by mini-css-extract-plugin
export default {"executables":"ExecutableIcons_executables__Fza5O","executable":"ExecutableIcons_executable__7068I"};